import { useState } from 'react'

import { ArcadeModalActionContext, ArcadeModalActionOverride } from './ArcadeModalActionContext'

export const ArcadeModalActionProvider = ({ children }: { children: React.ReactNode }) => {
  const [actionOverride, setActionOverride] = useState<ArcadeModalActionOverride | undefined>(undefined)

  return (
    <ArcadeModalActionContext.Provider value={{ actionOverride, setActionOverride }}>
      {children}
    </ArcadeModalActionContext.Provider>
  )
}
